module.exports = __webpack_public_path__ + "static/media/left_black_arrow.f0808a2c.svg";